import { ModuleName } from '../interfaces/modules/generic';

export const MODULE_ICON: { [K in ModuleName]: string } = {
  YES_NO: 'YesNoIcon',
  MULTIPLE_CHOICE: 'MultipleChoiceIcon',
  SINGLE_CHOICE: 'SingleChoiceIcon',
  FREE_TEXT: 'FreeTextIcon',
  LOCATION: 'LocationIcon',
  DATE: 'DateIcon',
  EMAIL: 'EmailIcon',
  PHONE_NUMBER: 'PhoneIcon',
  FILE_UPLOAD: 'FolderIcon',
  URL: 'LinkIcon',
  NUMBER: 'HashIcon',
  DROPDOWN: 'DropdownIcon',
  WIDGET: 'PlayIcon',
  SCHEDULE: 'ScheduleIcon',
  MATRIX_CHOICE: 'MatrixIcon',
  AVAILABILITY: 'ClockIcon',
  ID_ANALYZER: 'IDIcon',
  SECTION_BREAK: 'InfoIcon',
  THANK_YOU: 'HappyFaceIcon',
  REJECT: 'SadFaceIcon'
};

export const MODULE_COLOR: { [K in ModuleName]: string } = {
  YES_NO: '#F1B401',
  MULTIPLE_CHOICE: '#009688',
  SINGLE_CHOICE: '#00BCD4',
  FREE_TEXT: '#007ADB',
  LOCATION: '#4CAF4F',
  DATE: '#00A8F4',
  EMAIL: '#795548',
  PHONE_NUMBER: '#1CCF9A',
  FILE_UPLOAD: '#1C35C9',
  URL: '#C5D719',
  NUMBER: '#420DDA',
  DROPDOWN: '#9C27B0',
  WIDGET: '#D71996',
  SCHEDULE: '#E91E62',
  MATRIX_CHOICE: '#DA8300',
  AVAILABILITY: '#07C8BC',
  ID_ANALYZER: '#5DA687',
  SECTION_BREAK: '#FFA940',
  THANK_YOU: '#5AA4F5',
  REJECT: '#5AA4F5'
};

export const ANSWER_COMPONENTS = Object.freeze({
  TEXT: 'TextAnswer',
  SINGLE_SELECT: 'SingleSelectAnswer',
  MULTI_SELECT: 'MultiSelectAnswer',
  EMAIL: 'EmailAnswer',
  PHONE: 'PhoneAnswer',
  LINK: 'LinkAnswer',
  FILE: 'FileAnswer',
  WIDGET: 'WidgetAnswer',
  MATRIX: 'MatrixAnswer',
  SCHEDULE: 'ScheduleAnswer',
  ID_ANALYZER: 'IDAnalyzerAnswer',
  SECTION_BREAK: 'SectionBreakAnswer'
});

export const MODULE_ANSWER_COMPONENT: { [K in ModuleName]: typeof ANSWER_COMPONENTS[keyof typeof ANSWER_COMPONENTS] | null } = Object.freeze({
  [ModuleName.YES_NO]: ANSWER_COMPONENTS.SINGLE_SELECT,
  [ModuleName.MULTIPLE_CHOICE]: ANSWER_COMPONENTS.MULTI_SELECT,
  [ModuleName.SINGLE_CHOICE]: ANSWER_COMPONENTS.SINGLE_SELECT,
  [ModuleName.FREE_TEXT]: ANSWER_COMPONENTS.TEXT,
  [ModuleName.LOCATION]: ANSWER_COMPONENTS.TEXT,
  [ModuleName.DATE]: ANSWER_COMPONENTS.TEXT,
  [ModuleName.EMAIL]: ANSWER_COMPONENTS.EMAIL,
  [ModuleName.PHONE_NUMBER]: ANSWER_COMPONENTS.PHONE,
  [ModuleName.FILE_UPLOAD]: ANSWER_COMPONENTS.FILE,
  [ModuleName.URL]: ANSWER_COMPONENTS.LINK,
  [ModuleName.NUMBER]: ANSWER_COMPONENTS.TEXT,
  [ModuleName.DROPDOWN]: ANSWER_COMPONENTS.SINGLE_SELECT,
  [ModuleName.WIDGET]: ANSWER_COMPONENTS.WIDGET,
  [ModuleName.SCHEDULE]: ANSWER_COMPONENTS.SCHEDULE,
  [ModuleName.MATRIX_CHOICE]: ANSWER_COMPONENTS.MATRIX,
  [ModuleName.AVAILABILITY]: ANSWER_COMPONENTS.MATRIX,
  [ModuleName.ID_ANALYZER]: ANSWER_COMPONENTS.ID_ANALYZER,
  [ModuleName.SECTION_BREAK]: ANSWER_COMPONENTS.SECTION_BREAK,
  [ModuleName.THANK_YOU]: null,
  [ModuleName.REJECT]: null
});
